import { render, staticRenderFns } from "./group-progress-chart.vue?vue&type=template&id=1531d56b&scoped=true"
import script from "./group-progress-chart.vue?vue&type=script&lang=js"
export * from "./group-progress-chart.vue?vue&type=script&lang=js"
import style0 from "./group-progress-chart.vue?vue&type=style&index=0&id=1531d56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531d56b",
  null
  
)

export default component.exports